// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-764c6f5c] .button-vue--vue-secondary{box-shadow:none}`, "",{"version":3,"sources":["webpack://./src/components/Outbox.vue"],"names":[],"mappings":"AACA,6CACC,eAAA","sourcesContent":["\n:deep(.button-vue--vue-secondary) {\n\tbox-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
